import { render, staticRenderFns } from "./syncOrder.vue?vue&type=template&id=4fcc8a16&scoped=true"
import script from "./syncOrder.vue?vue&type=script&lang=js"
export * from "./syncOrder.vue?vue&type=script&lang=js"
import style0 from "./syncOrder.vue?vue&type=style&index=0&id=4fcc8a16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcc8a16",
  null
  
)

export default component.exports